import actions from './actions';

const initialState = {
  userData: null,
  userLoading: true,
  error: null,
};

const {
  USER_BEGIN,
  USER_SUCCESS,
  USER_ERR
} = actions;

const userDataReducer = (state = initialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case USER_BEGIN:
      return {
        ...state,
        userLoading: true,
      };
    case USER_SUCCESS:
      return {
        ...state,
        userData: data,
        userLoading: false,
      };
    case USER_ERR:
      return {
        ...state,
        error: err,
        userLoading: true,
      };
    default:
      return state;
  }
};

export default userDataReducer;
